import React, { Fragment, useCallback, useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";

const ViewPrograms = () => {
  const initialIndex = { index: 0, isOpen: false };
  const [exerciseIndex, setExerciseIndex] = useState(initialIndex);
  const [exercises, setExercises] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("fitnessChallangeSchema");
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.userToken);

  const fetchExercises = async (filter) => {
    setLoading(true); // Set loading to true before API call
    try {
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/home/getWorkOutTypes`,
        {
          workOut: filter,
        },
        config
      );
      setExercises(response.data.selectedModel);
    } catch (error) {
      console.error("Error fetching exercises:", error);
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };

  useEffect(() => {
    fetchExercises(selectedFilter);
  }, [selectedFilter]);

  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
  };

  const callback = useCallback((exercise) => {
    setExerciseIndex(exercise);
  }, []);

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Exercises" parent="Exercises" title="All Exercises" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <div className="mb-3">
              <label htmlFor="filter" className="form-label">Select Exercise Type:</label>
              <div className="input-group">
                <select
                  id="filter"
                  className="form-select"
                  value={selectedFilter}
                  onChange={handleFilterChange}
                >
                  <option value="workOutModel">Workout Model</option>
                  <option value="workOutProgramSchema">Workout Program</option>
                  <option value="singleWorkOutSchema">Single Workout</option>
                  <option value="fitnessChallangeSchema">Fitness Challenge</option>
                </select>
                <button className="btn btn-outline-secondary" type="button">
                  <i className="bi bi-chevron-down"></i>
                </button>
              </div>
            </div>
            {loading ? (
              <div className="text-center my-5">
                <Spinner style={{ width: '3rem', height: '3rem' }} />
              </div>
            ) : (
              <AllExercisesTable
                exercises={exercises}
                setExerciseIndex={callback}
                exerciseIndex={exerciseIndex}
                selectedFilter={selectedFilter}
              />
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ViewPrograms;

const AllExercisesTable = ({ exercises, setExerciseIndex, exerciseIndex, selectedFilter }) => {
  const [modal, setModal] = useState(false);
  const [selectedExercise, setSelectedExercise] = useState(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  const handleDelete = (exercise) => {
    setSelectedExercise(exercise);
    toggleModal();
  };

  const confirmDelete = () => {
    console.log("Deleting exercise:", selectedExercise);
    // Add the logic to delete the exercise from the server/database here
    toggleModal();
  };

  const history = useNavigate();

  const handleViewDetails = (exercise) => {
    history(`/exercises/${exercise.id}`);
  };

  const handleEdit = (exercise) => {
    switch (selectedFilter) {
      case 'workOutModel':
        history(`/programs/daily/${exercise._id}`);
        break;
      case 'workOutProgramSchema':
        history(`/programs/workout/${exercise._id}`);
        break;
      case 'singleWorkOutSchema':
        history(`/programs/single-exercise/${exercise._id}`);
        break;
      case 'fitnessChallangeSchema':
        history(`/programs/fitness-Challenges/${exercise._id}`);
        break;
      default:
        console.error("Unknown filter type:", selectedFilter);
        break;
    }
  };

  const handleViewInquiry = (exercise) => {
    history("/inquiry");
  };

  const customColumns = [
    {
      name: "Title",
      selector: (row) => row.title || row.workOutName,
      sortable: true,
      center: false,
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.exercisePicUrl}
          alt={row.title || row.workOutName}
          style={{ width: "100px", height: "110px" }}
        />
      ),
      sortable: false,
      center: true,
    },
    {
      name: "Category",
      selector: () => {
        switch (selectedFilter) {
          case 'workOutModel':
            return 'Workout Model';
          case 'workOutProgramSchema':
            return 'Workout Program';
          case 'singleWorkOutSchema':
            return 'Single Workout';
          case 'fitnessChallangeSchema':
            return 'Fitness Challenge';
          default:
            return 'Unknown Category';
        }
      },
      sortable: true,
      center: false,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Button
            color=""
            onClick={() => handleEdit(row)}
            style={{ padding: "0.25rem", marginRight: "0.5rem" }}
          >
            <i className="icon-pencil"></i>
          </Button>
          {/* <Button
            color=""
            onClick={() => handleDelete(row)}
            style={{ padding: "0.25rem", marginRight: "0.5rem" }}
          >
            <i className="icon-trash"></i>
          </Button> */}
          {/* <Button
            color=""
            onClick={() => handleViewDetails(row)}
            style={{ padding: "0.25rem" }}
          >
            <i className="icon-more-alt"></i>
          </Button> */}
        </div>
      ),
      button: true,
      width: "20%",
      center: true,
    },
  ];

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <h3>View Exercises</h3>
          </div>
        </div>
      </div>
      <div className="table-responsive support-table mt-2">
        <DataTable
          columns={customColumns}
          data={exercises}
          striped={true}
          center={true}
          pagination
          className="p-2"
        />
      </div>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Confirm Delete</ModalHeader>
        <ModalBody>
          Are you sure you want to delete the exercise titled "
          {selectedExercise?.title || selectedExercise?.workOutName}"?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Delete
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

